import Swiper from 'swiper';
import { Keyboard, Autoplay } from 'swiper/modules';
import { onDomReady } from '../../JavaScript/on-dom-ready';

onDomReady(() => {
  for (const slider of document.getElementsByClassName('slider--hero')) {
    const swiperElement = slider.querySelector('.swiper');
    if (!(swiperElement instanceof HTMLElement)) {
      continue;
    }

    new Swiper(swiperElement, {
      modules: [Keyboard, Autoplay],
      spaceBetween: 16,
      slidesPerView: 1,
      autoHeight: true,
      autoplay: {
        delay: 6000,
        pauseOnMouseEnter: true,
      }
    });
  }
});
